import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';

export interface RigAdminItem {
  id: number;
  name: string;
  rigType: string | null;
  rigDivision: string | null;
  isAvailable: boolean;
  hasActiveAssignment: boolean;
}

export interface RigAdminGroupedDto {
  availableRigs: RigAdminItem[];
  unavailableRigs: RigAdminItem[];
}

export interface AddRigRequest {
  name: string;
  rigType: string;
}

export interface UpdateRigTypeRequest {
  rigType: string;
}

@Injectable({ providedIn: 'root' })
export class RigsAdminApiService {
  private _http = inject(HttpClient);
  private readonly _baseUrl = environment.apiUrl;

  getGroupedRigs(): Observable<RigAdminGroupedDto> {
    return this._http.get<RigAdminGroupedDto>(`${this._baseUrl}/rig-admin`);
  }

  addRig(request: AddRigRequest): Observable<RigAdminItem> {
    return this._http.post<RigAdminItem>(`${this._baseUrl}/rig-admin`, request);
  }

  updateRigType(id: number, request: UpdateRigTypeRequest): Observable<RigAdminItem> {
    return this._http.put<RigAdminItem>(`${this._baseUrl}/rig-admin/${id}/rig-type`, request);
  }

  deactivateRig(id: number): Observable<RigAdminItem> {
    return this._http.post<RigAdminItem>(`${this._baseUrl}/rig-admin/${id}/deactivate`, {});
  }

  reactivateRig(id: number): Observable<RigAdminItem> {
    return this._http.post<RigAdminItem>(`${this._baseUrl}/rig-admin/${id}/reactivate`, {});
  }

  deleteRig(id: number): Observable<void> {
    return this._http.delete<void>(`${this._baseUrl}/rig-admin/${id}`);
  }
}